import { PromocodeField } from '@smgl/ui-kit';
import { memo } from 'react';
import { Control, Controller, useFormContext } from 'react-hook-form';

import { FormType } from '../../../../ui/PayPage.scheme';
import { useLocalization } from '../../localization/localization';

import { WarningMessage } from './Promocode.ui';

type PromocodeProps = {
  inputValue: string;
  status: 'idle' | 'applied' | 'cancelledByEdit';
  isApplying: boolean;
  onApply: (code: string) => void;
  onInput: (value: string) => void;
  onReset: () => void;
  control: Control<FormType>;
};

export const Promocode = memo(
  ({
    inputValue,
    status,
    isApplying,
    onApply,
    onInput,
    onReset,
    control,
  }: PromocodeProps) => {
    const { t } = useLocalization();
    const { setError } = useFormContext<FormType>();

    const isApplied = status === 'applied';
    const isCancelled = status === 'cancelledByEdit';
    const isApplyButtonDisabled = !inputValue.trim();

    return (
      <Controller
        control={control}
        name="promocode"
        render={({ fieldState: { error } }) => (
          <PromocodeField
            value={inputValue}
            label={t('promocode_label')}
            placeholder={t('promocode_placeholder')}
            onApply={() => onApply(inputValue)}
            isLoading={isApplying}
            isSuccess={isApplied}
            isError={!isApplied && !isCancelled && !!error?.message}
            error={!isApplied && !isCancelled ? error?.message : undefined}
            description={
              isCancelled ? (
                <WarningMessage>{t('promocode_cancelled')}</WarningMessage>
              ) : undefined
            }
            onChange={(value) => {
              const cleanValue = value
                .replace(/[^a-zA-Z0-9]/g, '')
                .slice(0, 256)
                .toUpperCase();

              onInput(cleanValue);

              if (error?.message) {
                setError('promocode', { message: undefined });
              }
            }}
            onReset={onReset}
            buttonText={t('promocode_apply_button')}
            isApplyButtonDisabled={isApplyButtonDisabled}
          />
        )}
      />
    );
  },
);
